import { defineMessages } from "react-intl";

const messages = defineMessages({
    notPlayable: {
        id: "planCard.notPlayable",
    },
});

export default messages;